<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" @click.self="close">
            <div class="modal-container rounded-8" role="dialog" aria-label="Tutorial en video">
                <div class="modal-body">
                    <div class="d-flex justify-content-end mb-2">
                        <button 
                            class="btn btn-link close-button" 
                            @click="close"
                            aria-label="Cerrar modal"
                        >
                            <i class="fa fa-times fa-2x"></i>
                        </button>
                    </div>
                    <iframe 
                        class="video-iframe" 
                        :src="url" 
                        title="Tutorial en video" 
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ModalTutorial',
    props: {
        url: { type: String, required: true }
    },
    emits: ['onClose'],
    methods: {
        close() {
            this.$emit('onClose');
        }
    }
};
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.modal-container {
    background: #FFFFFF;
    box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.3);
    max-width: 90vw;
    max-height: 90vh;
}

.modal-body {
    padding: 1rem;
}

.close-button {
    color: #1A0054;
    padding: 0.5rem;
    transition: transform 0.2s;
}

.close-button:hover {
    transform: scale(1.1);
    color: #4000bc;
}

.video-iframe {
    width: 75vw;
    height: 75vh;
    max-width: 100%;
    border-radius: 0.5rem;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
    transition: transform 0.3s ease;
}

.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
    transform: scale(0.9);
}

@media (max-width: 768px) {
    .video-iframe {
        width: 90vw;
        height: 50vh;
    }
}
</style>
